<template>
  <div class="select-field">
    <CustomDropdown
      :id="id"
      :name="name"
      :placeholder="placeholder"
      :options="formattedOptions"
      :value="value"
      color="black"
      @input="$emit('input', $event)"
      class="select-field-dropdown"
    />
    <p v-if="text" class="component_text">{{text}}</p>
  </div>
</template>

<script>
import CustomDropdown from './CustomDropdown.vue'

export default {
  components: {
    CustomDropdown
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedOptions() {
      return this.options.map(opt => ({
        key: opt.value,
        text: opt.label,
        disabled: opt.disabled
      }))
    }
  }
}
</script>

<style scoped>
.select-field {
  padding: 0.5rem 0.25rem 0.5rem 0;
  border-bottom: 1px solid #E5E5E5;
}

.component_text {
  background: gray;
  border: 1px solid black;
  box-shadow: 5px 5px 5px lightslategray;
  color: white;
  padding: 5px;
  margin-top: 0.5rem;
}
</style>
